import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import VisitUs from "../components/VisitUs";
import { gsap } from "gsap";
import { useNavigate } from "react-router-dom";

export default function Overview() {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("RESIDENTIAL");
  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 500);
    let mm = gsap.matchMedia();
    mm.add("(min-width: 800px)", () => {
      gsap
        .to("#topic1", {
          position: "fixed",
          top: "25vh",
          marginTop: "0px",
          duration: 0,
          scrollTrigger: {
            start: 1950,
            trigger: "#intro",
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic2", {
          position: "fixed",
          top: "35vh",
          duration: 0,
          scrollTrigger: {
            start: 2370,
            trigger: "#topic2",
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic3", {
          position: "fixed",
          top: "45vh",
          duration: 0,
          scrollTrigger: {
            start: 2820,
            trigger: ".description",
            // pin: true,
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
      gsap
        .to("#topic4", {
          position: "fixed",
          top: "55vh",
          duration: 0,
          scrollTrigger: {
            start: 3350,
            trigger: "#topic4",
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();

      gsap
        .to("#topic5", {
          position: "fixed",
          top: "65vh",
          duration: 0,
          scrollTrigger: {
            start: 3750,
            trigger: "#topic5",
            // pin: true,
            end: 10000,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();

      gsap
        .to(".topic", {
          opacity: 0,
          duration: 0.25,
          scrollTrigger: {
            start: 3800,
            trigger: "#topic4",
            // pin: true,
            end: 2600,
            toggleActions: "play none none reverse",
          },
        })
        .reverse();
    });
  }, []);

  const dispatch = useDispatch();
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/bg7.jpg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textAlign: "center",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Admissions in BGS WORLD SCHOOL
          </div>
        </div>
        <div
          style={{
            padding: state.auth.isMobile
              ? "100px 10% 100px 10%"
              : "100px 20% 100px 20%",
          }}
        >
          <Grid container spacing={5}>
            <Grid item xs={12} md={8}>
              <div
                style={{
                  fontSize: "35px",
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                One School. Many Possibilites.
              </div>

              <p>
                BGS WORLD SCHOOL educates academically talented students to
                become state, national, and global leaders in science,
                technology, engineering, and mathematics. Founded as the
                nation’s first public, residential STEM high school, we let
                North Carolina students design your future through challenging
                programs driven by instructional excellence and the excitement
                of discovery.
              </p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <Button
                onClick={() => {
                  navigate("/register");
                }}
                style={{
                  border: "2px #005a32 solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#005a32",
                  fontFamily: "Montserrat",
                }}
              >
                Apply Now
              </Button>
              <br />
              <Button
                onClick={() => {
                  navigate("/register");
                }}
                style={{
                  border: "2px #d7301f solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#d7301f",
                  fontFamily: "Montserrat",
                }}
              >
                Register
              </Button>

              <Button
                onClick={() => {
                  navigate("/about_school");
                }}
                style={{
                  border: "2px #4a1486 solid",
                  borderRadius: "35px",
                  width: "100%",
                  height: "60px",
                  fontSize: "18px",
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "25px",
                  backgroundColor: "#4a1486",
                  fontFamily: "Montserrat",
                }}
              >
                About us
              </Button>
            </Grid>
          </Grid>
        </div>
        <div style={{ backgroundColor: themeStyle.primaryColor }}>
          <div style={{ padding: "100px 50px 100px 50px" }}>
            <Grid container spacing={1}>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <div
                  style={{
                    fontSize: "45px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    color: "white",
                    textAlign: state.auth.isMobile ? "center" : "left",
                  }}
                >
                  Explore Our Programs
                </div>
                {!state.auth.isMobile ? (
                  <Grid
                    container
                    spacing={10}
                    style={{
                      marginTop: "0px",
                    }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                      <Button
                        onClick={() => {
                          dispatch({
                            type: "NAV_COLOR",
                            payload: { navColor: "#000c66", navOpacity: 1 },
                          });
                          setSelectedTab("RESIDENTIAL");
                        }}
                        style={{
                          border:
                            selectedTab == "RESIDENTIAL"
                              ? "2px solid " + themeStyle.secondaryButtonColor
                              : "2px solid #ddd",
                          borderRadius: "35px",
                          width: "100%",
                          height: "60px",
                          fontSize: "18px",
                          color:
                            selectedTab == "RESIDENTIAL"
                              ? "white"
                              : themeStyle.secondaryButtonColor,
                          fontWeight: "bold",
                          marginBottom: "25px",
                          backgroundColor:
                            selectedTab == "RESIDENTIAL"
                              ? themeStyle.secondaryButtonColor
                              : "white",
                          fontFamily: "Montserrat",
                        }}
                      >
                        RESIDENTIAL
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                      <Button
                        onClick={() => {
                          dispatch({
                            type: "NAV_COLOR",
                            payload: { navColor: "#000c66", navOpacity: 1 },
                          });
                          setSelectedTab("VIRTUAL");
                        }}
                        style={{
                          border:
                            selectedTab == "VIRTUAL"
                              ? "2px solid " + themeStyle.secondaryButtonColor
                              : "2px solid #ddd",
                          borderRadius: "35px",
                          width: "100%",
                          height: "60px",
                          fontSize: "18px",
                          color:
                            selectedTab == "VIRTUAL"
                              ? "white"
                              : themeStyle.secondaryButtonColor,
                          fontWeight: "bold",
                          marginBottom: "25px",
                          backgroundColor:
                            selectedTab == "VIRTUAL"
                              ? themeStyle.secondaryButtonColor
                              : "white",
                          fontFamily: "Montserrat",
                        }}
                      >
                        VIRTUAL
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                      <Button
                        onClick={() => {
                          dispatch({
                            type: "NAV_COLOR",
                            payload: { navColor: "#000c66", navOpacity: 1 },
                          });
                          setSelectedTab("SUMMER");
                        }}
                        style={{
                          border:
                            selectedTab == "SUMMER"
                              ? "2px solid " + themeStyle.secondaryButtonColor
                              : "2px solid #ddd",
                          borderRadius: "35px",
                          width: "100%",
                          height: "60px",
                          fontSize: "18px",
                          color:
                            selectedTab == "SUMMER"
                              ? "white"
                              : themeStyle.secondaryButtonColor,
                          fontWeight: "bold",
                          marginBottom: "25px",
                          backgroundColor:
                            selectedTab == "SUMMER"
                              ? themeStyle.secondaryButtonColor
                              : "white",
                          fontFamily: "Montserrat",
                        }}
                      >
                        SUMMER
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                      <Button
                        onClick={() => {
                          dispatch({
                            type: "NAV_COLOR",
                            payload: { navColor: "#000c66", navOpacity: 1 },
                          });
                          setSelectedTab("ACADEMIC");
                        }}
                        style={{
                          border:
                            selectedTab == "ACADEMIC"
                              ? "2px solid " + themeStyle.secondaryButtonColor
                              : "2px solid #ddd",
                          borderRadius: "35px",
                          width: "100%",
                          height: "60px",
                          fontSize: "18px",
                          color:
                            selectedTab == "ACADEMIC"
                              ? "white"
                              : themeStyle.secondaryButtonColor,
                          fontWeight: "bold",
                          marginBottom: "25px",
                          backgroundColor:
                            selectedTab == "ACADEMIC"
                              ? themeStyle.secondaryButtonColor
                              : "white",
                          fontFamily: "Montserrat",
                        }}
                      >
                        ACADEMIC
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "0px 10% 100px 10%",
            }}
          >
            <div style={{ color: "white" }}>
              <div style={{ fontSize: "35px", fontWeight: "600" }}>
                BGS WORLD
              </div>
              <br />
              <b> Welcome to BGS World School</b> <br /> <br /> 1. The location
              of a school has an enormous significance; our school is far away
              from the noises and the pollution. The ambience is calm, spacious
              with good amenities and utilities in a visually appealing
              landscape. <br /> <br /> 2. The backbone of any school’s
              infrastructure is the classroom. We have adequate classrooms which
              are pleasant with modern learning experience.
              <br /> <br /> 3. Enriching young minds with value based Education.
              We strive to offer true education that teaches and imbibes
              universal values and morals, builds courage, instills
              self-confidence, and fosters a sense of responsibility in the
              children. <br /> <br />
              4. A competent teacher plays a vital role in the growth of the
              child. Our teachers are highly qualified, value-driven, passionate
              and experienced. <br /> <br />
              5. The events and activities are part of the curriculum which aims
              at instilling discipline, ethics and values in students that would
              help them to develop their personality to become better citizens
              of the world.
            </div>
          </div>
        </div>
        <div
          style={{
            padding: "100px 50px 100px 50px",
            background:
              "linear-gradient(to bottom, #4178ba , #000080, #000080)",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              color: "white",
              fontWeight: "600",
              textAlign: "left",
              margin: "0px 0px 150px 0px",
            }}
          >
            How to appy for admission
          </div>

          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="topic"
                id="topic1"
                style={{ marginTop: state.auth.isMobile ? "-100px" : "0px" }}
              >
                1) Register
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="description"
                style={{
                  width: state.auth.isMobile ? "125%" : "100%",
                  marginLeft: state.auth.isMobile ? "-35px" : "0px",
                }}
              >
                <img
                  class="descimg"
                  src="https://global-uploads.webflow.com/62b5e5f0af534cc2238ff048/63160243cf6f3b0e6a51f519_Group%201000007307.png"
                />
                <br />
                The child must meet the age requirement for the class they are
                applying to. For example, admission to Nursery typically
                requires the child to be at least 3 years old as of June 1st of
                the academic year. Age eligibility for other classes increases
                accordingly.
              </div>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div style={{ textAlign: "left" }} className="topic" id="topic2">
                2) Submit the documents
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="description"
                style={{
                  width: state.auth.isMobile ? "125%" : "100%",
                  marginLeft: state.auth.isMobile ? "-35px" : "0px",
                }}
              >
                <img
                  className="descimg"
                  src="https://global-uploads.webflow.com/62b5e5f0af534cc2238ff048/6316021d12974b0b3acd8fd1_Group%201000007303%20(1).png"
                />
                <br />
                Parents must provide essential documents, including: Birth
                certificate Transfer certificate (if applicable) Academic
                records or progress reports (for higher grades) Address proof
                and identification (Aadhaar, Passport, etc.) Passport-sized
                photographs of the student and parents
              </div>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="topic" id="topic3">
                3)Entrance exam
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="description"
                style={{
                  width: state.auth.isMobile ? "125%" : "100%",
                  marginLeft: state.auth.isMobile ? "-35px" : "0px",
                }}
              >
                <img
                  className="descimg"
                  src="https://global-uploads.webflow.com/62b5e5f0af534cc2238ff048/631601fcf920dd338e2e3584_Group%201000007302%20(2).png"
                />
                <br />
                Students applying for grades beyond Kindergarten are required to
                undergo a written test and/or an interview to assess their
                academic readiness and subject knowledge. The syllabus for the
                assessment is shared during the admission process.
              </div>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div style={{ textAlign: "left" }} className="topic" id="topic4">
                4) Interview
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="description"
                style={{
                  width: state.auth.isMobile ? "125%" : "100%",
                  marginLeft: state.auth.isMobile ? "-35px" : "0px",
                }}
              >
                <img
                  className="descimg"
                  src="https://global-uploads.webflow.com/62b5e5f0af534cc2238ff048/631601fcf920dd338e2e3584_Group%201000007302%20(2).png"
                />
                <br />A face-to-face interaction or counseling session is
                conducted with the student and parents to understand their
                expectations and ensure alignment with the school’s philosophy
                and values.
              </div>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div className="topic" id="topic5">
                5) Payment of Admission Fees
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
              <div
                className="description"
                style={{
                  width: state.auth.isMobile ? "125%" : "100%",
                  marginLeft: state.auth.isMobile ? "-35px" : "0px",
                }}
              >
                <img
                  className="descimg"
                  src="https://global-uploads.webflow.com/62b5e5f0af534cc2238ff048/631601fcf920dd338e2e3584_Group%201000007302%20(2).png"
                />
                <br />
                Once eligibility is confirmed, parents must complete the
                admission process by paying the registration and admission fees
                as per the school’s guidelines. This secures the seat for the
                student in the desired class.
              </div>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </div>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
